import { WasteKind } from "encamp-prisma/generated/browser";

import { prettyPrintEnumValue } from "../utils/prettyPrintEnumValue";

/**
 * A waste stream's management program on its own, blank when no special
 * program applies.
 *
 * Blank rather than "RCRA" so a scan down a Management Program column (the
 * waste streams grid and its export) surfaces only the streams on a special
 * program. A null kind reads the same way, whether it was never derived or the
 * tenant's feature flag withholds it.
 *
 * This is the single place the "RCRA or null means no program" rule lives.
 */
export const prettyPrintWasteProgram = (wasteKind: WasteKind | null | undefined): string =>
  !wasteKind || wasteKind === WasteKind.RCRA ? "" : prettyPrintEnumValue(wasteKind);
